import { Box } from '@mui/material';
import React from 'react';

import Text from './base/text';

import { useAuthorization } from '~/client/hooks/use-authorization';
import { useUserProfile } from '~/client/hooks/user-profile';

// ControlGen and Witness are beta features. Pages say so to someone without
// the flag (FeatureAuth would send them to sign-in); menus and tabs simply hide.

interface Props {
  children: React.ReactNode;
  /** Render nothing instead of the notice: for menu entries, tabs and cards. */
  hidden?: boolean;
}

export function useIsBetaUser(): { isBeta: boolean; isLoading: boolean } {
  const auth = useAuthorization();
  const { isLoading } = useUserProfile();
  return { isBeta: auth.isBetaUser(), isLoading };
}

const BetaOnly: React.FC<Props> = ({ children, hidden = false }) => {
  const { isBeta, isLoading } = useIsBetaUser();
  if (isBeta) {
    return <>{children}</>;
  }
  if (hidden || isLoading) {
    return null;
  }
  return (
    <Box sx={{ p: 4 }}>
      <Text sz="h4">This feature is in beta</Text>
      <Text sz="body14" sx={{ mt: 1 }}>
        It is available to beta users only. Ask your Fairly contact to add you
        to the beta.
      </Text>
    </Box>
  );
};

export default BetaOnly;
